import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import sizes from "./sizes";
/**
 * An icon showing up.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function HamburgerIcon({ className, size = "small" }) {
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: "middle",
        }, className: className, viewBox: "0 0 20 20", children: _jsxs("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "square", strokeWidth: "1", children: [_jsx("path", { d: "M0 17L20 17" }), _jsx("path", { d: "M-0.5 3L19.5 3" }), _jsx("path", { d: "M0 10L20 10" })] }) }));
}
//# sourceMappingURL=HamburgerIcon.js.map